import { useQuery } from "@tanstack/react-query";

import { getPortalConfig } from "@/api/portal";

/** Конфигурация портала. Меняется только с деплоем — грузим один раз.
 *  Ошибку загрузки вызывающий показывает, а не подменяет «SSO выключен». */
export function usePortalConfig() {
  return useQuery({
    queryKey: ["portal-config"],
    queryFn: getPortalConfig,
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
  });
}
